import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';

export type PartyStatus =
  | 'COLLECTING'
  | 'SHIPPING'
  | 'ON_THE_WAY'
  | 'ON_CUSTOMS'
  | 'LOCAL_ON_THE_WAY'
  | 'SHIPMENT_ON_CUSTOMERS';

type Props = {
  status: PartyStatus;
  className?: string;
};

const STYLES: Record<PartyStatus, string> = {
  COLLECTING: 'bg-slate-100 text-slate-700 border-slate-200',
  SHIPPING: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  ON_THE_WAY: 'bg-sky-100 text-sky-800 border-sky-200',
  ON_CUSTOMS: 'bg-amber-100 text-amber-800 border-amber-200',
  LOCAL_ON_THE_WAY: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  SHIPMENT_ON_CUSTOMERS: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const PARTY_STATUS_VALUES: readonly PartyStatus[] = [
  'COLLECTING',
  'SHIPPING',
  'ON_THE_WAY',
  'ON_CUSTOMS',
  'LOCAL_ON_THE_WAY',
  'SHIPMENT_ON_CUSTOMERS',
] as const;

export const PartyStatusChip = ({ status, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip tone={STYLES[status]} className={className}>
      {t(`partyStatus.${status}`)}
    </Chip>
  );
};
